import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ImagePreload extends Component {
  render() {
    const { onImageLoad, src } = this.props;
    return (
      <div className="ImagePreload">
        <img onLoad={onImageLoad} src={src} alt="" />
      </div>
    );
  }
}

ImagePreload.propTypes = {
  src: PropTypes.string.isRequired,
  onImageLoad: PropTypes.func
};

export default ImagePreload;



// WEBPACK FOOTER //
// ./src/components/common/ImagePreload/index.jsx